import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ResizedDirective } from './resized.directive';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule
  ],
  declarations: [
    ResizedDirective,
  ],
  exports: [
    ResizedDirective,
  ]
})
export class ResizedModule { }
